const addToCartBtn = document.querySelector(".product-purchase-form .purchase-btn");

export default function init() {
  addToCartBtn.addEventListener("click", () => {
    console.log("Add to bag functionality hasn't been built yet");
  });
}
